// https://ant.design/components/page-header/

import { CloseOutlined } from '@ant-design/icons'
import React from 'react'

import Button from 'components/atoms/Button'
import Message, { MessageType } from 'components/atoms/Intl/Message'
import { useIsMobileWindowSize } from 'hooks/useWindowSize'
import Avatar, { AvatarProps } from 'stories/components/atoms/Avatar/Avatar'
import eqDSTheme from 'styles/eqDSTheme'

export interface PageHeaderProps {
  title?: MessageType
  subTitle?: MessageType
  avatar?: AvatarProps
  backIcon?: React.ReactNode
  onBack?: (e?: React.MouseEvent<HTMLElement>) => void
  tags?: React.ReactElement
  extra?: React.ReactNode
}

const PageHeader = (props: PageHeaderProps) => {
  const isMobileWindowSize = useIsMobileWindowSize()

  return (
    <div
      className="page-header"
      style={{
        display: 'flex',
        flexDirection: 'row',
        padding: isMobileWindowSize
          ? eqDSTheme.space.small
          : eqDSTheme.space.medium,
        backgroundColor: eqDSTheme.color.white,
      }}
    >
      {props.onBack && (
        <div
          className="page-header_back"
          style={{
            paddingRight: isMobileWindowSize
              ? eqDSTheme.space.small
              : eqDSTheme.space.medium,
          }}
        >
          <Button
            icon={props.backIcon ?? <CloseOutlined />}
            type="text"
            onClick={props.onBack}
          />
        </div>
      )}
      {props.avatar && (
        <div
          className="page-header_avatar"
          style={{
            paddingRight: isMobileWindowSize
              ? eqDSTheme.space.small
              : eqDSTheme.space.medium,
          }}
        >
          <Avatar {...props.avatar} />
        </div>
      )}
      <div
        className="page-header_text"
        style={{
          display: 'flex',
          flexDirection: isMobileWindowSize ? 'column' : 'row',
          gap: eqDSTheme.space.small,
          flex: 1,
          alignItems: isMobileWindowSize ? 'flex-start' : 'center',
        }}
      >
        <span
          className="page-header_text_title"
          style={{
            fontSize: isMobileWindowSize
              ? eqDSTheme.fontSize.large
              : eqDSTheme.fontSize.xlarge,
            fontWeight: eqDSTheme.fontWeight.semiBold,
            color: eqDSTheme.color.primary,
          }}
        >
          <Message value={props.title} />
        </span>
        <div
          className="page-header_text_subtitle"
          style={{
            display: 'flex',
            gap: eqDSTheme.space.small,
            alignItems: 'center',
          }}
        >
          <span
            style={{
              fontSize: isMobileWindowSize
                ? eqDSTheme.fontSize.small
                : eqDSTheme.fontSize.medium,
              color: eqDSTheme.color.grey,
            }}
          >
            <Message value={props.subTitle} />
          </span>
          {props.tags}
        </div>
      </div>
      {props.extra}
    </div>
  )
}

export default React.memo(PageHeader)
